import { IconLayoutList } from "@tabler/icons-react";

import { Text } from "@fragments";
import Feed from "@components/Feed";

import GroupTabs from "./components/GroupTabs";
import GroupHeader from "./components/GroupHeader";
import GroupMeta from "./components/GroupMeta";
import GroupNoAccess from "./components/GroupNoAccess";
import CreatePostButton from "./components/CreatePostButton";
import GroupLoadingSkeleton from "./components/GroupLoadingSkeleton";
import Gamification from "./components/Gamification";

import "./styles.scss";

export default function GroupView({
    community,
    user,
    group,
    groupInfo,
    loadingGroupInfo,
    hasAccess,
    groupAvailability,
    isAdmin,
    tabsAnchorRef,
    groupContainerRef,
    feedRefreshKey,
    handleChangeGroup,
    handleCreatePost,
    triggerEdit,
}) {
    const createPostEnabled =
        hasAccess &&
        !loadingGroupInfo &&
        !!groupInfo?.interactions_enabled;

    return (
        <div ref={groupContainerRef} className="group">
            <div className="header mb-1 screen-padding mt-2 csf-2">
                <IconLayoutList size={20} />
                <Text.h3 contrast={8} className="bold pr-2">
                    Feed do grupo
                </Text.h3>
            </div>

            <div
                ref={tabsAnchorRef}
                className="groups-tab-sentinel"
                aria-hidden="true"
            />
            <GroupTabs
                groups={community.groups}
                currentGroupId={group}
                isAdmin={isAdmin}
                onChangeGroup={handleChangeGroup}
                onCreateGroup={() => triggerEdit()}
                onEditGroup={triggerEdit}
            />

            <div className="group-centered-wrapper">
                {loadingGroupInfo ? (
                    <GroupLoadingSkeleton />
                ) : (
                    <>
                        {groupInfo && (
                            <div className="group-card">
                                <GroupHeader groupInfo={groupInfo} />
                                {hasAccess && (
                                    <div className="group-meta-section">
                                        <GroupMeta
                                            description={groupInfo.description}
                                            links={groupInfo.links}
                                        />
                                        {groupInfo.type === "CHALLENGE" && (
                                            <Gamification
                                                groupInfo={groupInfo}
                                                groupId={group}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        {hasAccess ? (
                            group && (
                                <div className="feed-group">
                                    <Feed key={`${group}-${feedRefreshKey}`} fluidMode={true} groupId={group} />
                                </div>
                            )
                        ) : (
                            <GroupNoAccess
                                communityId={community.id}
                                availability={groupAvailability}
                            />
                        )}
                    </>
                )}
            </div>

            <CreatePostButton
                user={user}
                enabled={createPostEnabled}
                anchorRef={tabsAnchorRef}
                containerRef={groupContainerRef}
                onClick={handleCreatePost}
            />
        </div>
    );
}
